export default class NumberUtil {
  static toShortNumbers(numberArr, fixedSize = 2) {
    var shortnumbers = [];
    for (var i = 0; i < numberArr.length; i++) {
      shortnumbers.push(this.toShortNumber(numberArr[i], fixedSize));
    }
    return shortnumbers;
  }

  static toCommaNumbers(numberArr) {
    var results = [];
    for (var i = 0; i < numberArr.length; i++) {
      results.push(this.numberWithCommas(numberArr[i]));
    }
    return results;
  }

  static numberWithCommas(x) {
    if (x.toString() === "") return "-";

    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  static toShortNumber(number, fixedSize) {
    if (!number) {
      return "-";
    }
    var modifedString = number * 1; //Number(number);// Math.abs(number);

    if (modifedString >= 1000000000000 || modifedString <= -1000000000000) {
      modifedString = number / 1000000000000;
      modifedString = modifedString.toFixed(fixedSize);
      modifedString = this.numberWithCommas(modifedString);
      modifedString = modifedString + "조";
    } else if (modifedString >= 100000000 || modifedString <= -100000000) {
      modifedString = number / 100000000;
      modifedString = modifedString.toFixed(fixedSize);
      modifedString = this.numberWithCommas(modifedString);
      modifedString = modifedString + "억";
    } else if (modifedString >= 1000000 || modifedString <= -1000000) {
      modifedString = number / 1000000;
      modifedString = modifedString.toFixed(fixedSize);
      modifedString = this.numberWithCommas(modifedString);
      modifedString = modifedString + "백만";
    } else if (modifedString === 0) {
      modifedString = "-";
    } else if (modifedString === null) {
      modifedString = "-";
    } else if (modifedString < 0) {
      modifedString = modifedString.toFixed(fixedSize);
    } else {
      var checkString = modifedString.toFixed(fixedSize).toString();

      if (checkString.slice(-3) === ".00") {
        modifedString = modifedString.toFixed(0);
      } else {
        modifedString = modifedString.toFixed(fixedSize);
      }

      modifedString = this.numberWithCommas(modifedString);
    }

    return modifedString;
  }
}
